/**
 * @fileName      printService
 * @dateTime      2021/5/12 10:30
 * @author        Xing
 * @description   print service
 */

import io, { serverAlias } from '@/module/io'

class Print {
  /**
   * 获取打印安装版本文件
   *
   * @param {String}
   */
  getVersionInfLately (payload) {
    return new Promise((resolve, reject) => {
      io.get(`${serverAlias.dscloud}/1.0/ds/print/version/manage/getVersionInfLately`, { ...payload, _api: `${serverAlias.dscloud}` }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 获取打印安装版本文件
   *
   * @param {String}
   */
  getUserOfflineStores (payload) {
    return new Promise((resolve, reject) => {
      io.post(`${serverAlias.dscloud}/1.0/ds/baseinfo/my`, { ...payload, _api: `${serverAlias.dscloud}` }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 打印-测试打印
   *
   * @param {String}
   */
  testPrintAction (payload) {
    return new Promise((resolve, reject) => {
      io.post(`${serverAlias.dscloud}/1.0/ds/print/test/print/list`, { ...payload, _api: `${serverAlias.dscloud}` }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 打印-测试语音播报
   *
   * @param {String}
   */
  testVoiceAction (payload) {
    return new Promise((resolve, reject) => {
      io.post(`${serverAlias.dscloud}/1.0/ds/print/test/sound/list`, { ...payload, _api: `${serverAlias.dscloud}` }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
}

export default new Print()



// WEBPACK FOOTER //
// ./src/js/module/apis/printService.js